import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  NavLink as RouterLink,
  matchPath,
  useLocation,
} from "react-router-dom";
// material
import { alpha, useTheme, styled } from "@mui/material/styles";
import {
  Box,
  List,
  Collapse,
  ListItemText,
  ListItemIcon,
  ListItemButton,
} from "@mui/material";
//
import Iconify from "./Iconify";
import { useMoralis, useMoralisCloudFunction } from "react-moralis";

// ----------------------------------------------------------------------

const ListItemStyle = styled((props) => (
  <ListItemButton disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: "relative",
  textTransform: "capitalize",
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(2.5),
  color: theme.palette.text.secondary,
  "&:before": {
    top: 0,
    right: 0,
    width: 3,
    bottom: 0,
    content: "''",
    display: "none",
    position: "absolute",
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    backgroundColor: theme.palette.primary.main,
  },
}));

const ListItemIconStyle = styled(ListItemIcon)({
  width: 22,
  height: 22,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

// ----------------------------------------------------------------------

NavItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.func,
};

function NavItem({ item, active }) {
  const theme = useTheme();
  const isActiveRoot = active(item.path);
  const { title, path, icon, info, children } = item;
  const [open, setOpen] = useState(isActiveRoot);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const activeRootStyle = {
    fontWeight: "fontWeightMedium",
    bgcolor: alpha(
      theme.palette.primary.main,
      theme.palette.action.selectedOpacity
    ),
    "&:before": { display: "block" },
  };

  const activeSubStyle = {
    color: "text.primary",
    fontWeight: "fontWeightMedium",
  };

  if (children) {
    return (
      <>
        <ListItemStyle
          onClick={handleOpen}
          sx={{
            ...(isActiveRoot && activeRootStyle),
          }}
        >
          <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
          <ListItemText disableTypography primary={title} />
          {info && info}
          <Iconify
            icon={
              open
                ? "eva:arrow-ios-downward-fill"
                : "eva:arrow-ios-forward-fill"
            }
            sx={{ width: 16, height: 16, ml: 1 }}
          />
        </ListItemStyle>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children.map((item) => {
              const { title, path } = item;
              const isActiveSub = active(path);

              return (
                <ListItemStyle
                  key={title}
                  component={RouterLink}
                  to={path}
                  sx={{
                    ...(isActiveSub && activeSubStyle),
                  }}
                >
                  <ListItemIconStyle>
                    <Box
                      component="span"
                      sx={{
                        width: 4,
                        height: 4,
                        display: "flex",
                        borderRadius: "50%",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "text.disabled",
                        transition: (theme) =>
                          theme.transitions.create("transform"),
                        ...(isActiveSub && {
                          transform: "scale(2)",
                          bgcolor: "primary.main",
                        }),
                      }}
                    />
                  </ListItemIconStyle>
                  <ListItemText disableTypography primary={title} />
                </ListItemStyle>
              );
            })}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <ListItemStyle
      component={RouterLink}
      to={path}
      sx={{
        ...(isActiveRoot && activeRootStyle),
      }}
    >
      <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
      <ListItemText disableTypography primary={title} />
      {info && info}
    </ListItemStyle>
  );
}

NavSection.propTypes = {
  navConfig: PropTypes.array,
};

export default function NavSection({ navConfig, ...other }) {
  const { user } = useMoralis();
  const { pathname } = useLocation();
  const [roles, setRoles] = useState([]);
  const isOwner = localStorage.getItem("isOwner");
  const dao = localStorage.getItem("DAO");
  const rolel = localStorage.getItem("role");
  const match = (path) =>
    path ? !!matchPath({ path, end: false }, pathname) : false;

  const { fetch, data } = useMoralisCloudFunction("getRoles", {
    autoFetch: true,
  });

  useEffect(() => {
    setData();
  }, [data, user]);

  async function setData() {
    const rolesData = await JSON.parse(JSON.stringify(data));

    const rData =
      data &&
      rolesData.filter(
        (role) => role.dao == dao && role.tokenContract == rolel
      );

    rData && setRoles(rData[0]);
  }

  useEffect(() => {
    fetch();
  }, [user]);

  console.log(roles, "roles");

  return (
    <Box {...other}>
      <List disablePadding>
        {navConfig.map((item) => {
          if (
            item.key == "administration" &&
            isOwner == "false" &&
            roles.administration == true
          ) {
            return <NavItem key={item.title} item={item} active={match} />;
          } else if (
            item.key !== "administration" &&
            isOwner == "false" &&
            item.key == "dAOPay" && 
            roles.dAOPay == true
          ) {
            return <NavItem key={item.title} item={item} active={match} />;
          } else if (
            item.key !== "administration" &&
            isOwner == "false" &&
            item.key == "daodrive" &&
            roles.daodrive == true
          ) {
            return <NavItem key={item.title} item={item} active={match} />;
          } else if (
            item.key !== "administration" &&
            isOwner == "false" &&
            item.key == "daosupport" &&
            roles.daosupport == true
          ) {
            return <NavItem key={item.title} item={item} active={match} />;
          } else if (isOwner == "true") {
            return <NavItem key={item.title} item={item} active={match} />;
          }
        })}
      </List>
    </Box>
  );
}
